import {inject, InjectionToken, Signal} from '@angular/core';
import {AuthService, RoleValidator} from '../services/auth.service';
import {animationFrames, distinctUntilChanged, filter, map, scan} from 'rxjs';
import {toSignal} from '@angular/core/rxjs-interop';
import _ from 'lodash';

import menu from './menu.json';
import {SideNavItem, SideNavSection, SideNavSections, SideNavSectionsSchema} from '../model/menu.model';

const filterMenuItemByAcl = (item: SideNavItem, validator: RoleValidator) => {
  if (!item.acl) {
    return true;
  }
  let roles: string[];
  if (Array.isArray(item.acl.role)) {
    roles = item.acl.role;
  } else {
    roles = [item.acl.role];
  }
  return validator(roles, item.acl.resource);
}

const filteredMenu = (validator: RoleValidator) =>
  (s: SideNavItem) => filterMenuItemByAcl(s, validator);

const filteredSections = (sections: SideNavSection[], validator: RoleValidator) => {
  return sections.map(section => ({
    ...section,
    items: section.items.filter(filteredMenu(validator))
  }))

};

export const MENU_SECTIONS_TOKEN = new InjectionToken<Signal<SideNavSections>>('MENU_SECTIONS_TOKEN', {
  providedIn: 'root',
  factory: () => {
    const authService = inject(AuthService);
    const menuSectionStream$ = animationFrames().pipe(
      map(() => menu),
      filter((menu: unknown): menu is SideNavSections => SideNavSectionsSchema.safeParse(menu).success),
      scan((_acc, curr) => {
        return filteredSections(curr, authService.hasRole.bind(authService))
          .filter(s => s.items.length > 0);
      }, [] as SideNavSection[]),
      distinctUntilChanged((a, b) => _.isEqual(a, b)),
    );

    return toSignal(menuSectionStream$, {
      initialValue: [],
    })
  }
});
